module.exports = __webpack_public_path__ + "img/centaine.56933dd9.png";